import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { GiftsComponent } from './components/gifts/gifts.component';
import { GiftFormComponent } from './components/gifts/gift-form/gift-form.component';
import { GiftDetailsComponent } from './components/gifts/gift-details/gift-details.component';


import { QuestionsComponent } from './components/questions/questions.component';
import { QuestionFormComponent } from './components/questions/question-form/question-form.component';
import { QuestionDetailsComponent } from './components/questions/question-details/question-details.component';
import { ActivityComponent } from './components/activity/activity.component';

import { NotificationListComponent } from './components/notifications/notification-list.component';

import { MembersComponent } from './components/members/members.component';
import { MemberDetailsComponent } from './components/members/member-details/member-details.component';

import { ArticlesComponent } from './components/articles/articles.component';
import { ArticleFormComponent } from './components/articles/article-form/article-form.component';
import { ArticleDetailsComponent } from './components/articles/article-details/article-details.component';

import { QuizzesComponent } from './components/quizzes/quizzes.component';
import { QuizFormComponent } from './components/quizzes/quiz-form/quiz-form.component';
import { QuizDetailsComponent } from './components/quizzes/quiz-details/quiz-details.component';

import { EventsComponent } from './components/events/events.component';
import { EventFormComponent } from './components/events/event-form/event-form.component';
import { EventDetailsComponent } from './components/events/event-details/event-details.component';

import { ApplicationsComponent } from './components/applications/applications.component';
import { ApplicationFormComponent } from './components/applications/application-form/application-form.component';
import { ApplicationDetailsComponent } from './components/applications/application-details/application-details.component';


import { VideosComponent } from './components/videos/videos.component';
import { VideoFormComponent } from './components/videos/video-form/video-form.component';
import { VideoDetailsComponent } from './components/videos/video-details/video-details.component';


import { CategoriesComponent } from './components/categories/categories.component';
import { CategoryFormComponent } from './components/categories/category-form/category-form.component';
import { CategoryDetailsComponent } from './components/categories/category-details/category-details.component';

// Import Containers
import { DefaultLayoutComponent } from '../containers';
import { CompetitionDetailsComponent } from './components/competition/competition-details/competition-details.component';
import { CompetitionFormComponent } from './components/competition/competition-form/competition-form.component';
import { competitionsComponent } from './components/competition/competition.component';
import { ListComponent } from './components/list/list.component';
import { LocationComponent } from './components/location/location.component';
import { StatsComponent } from './components/stats/stats.component';

import { NotificationSchedulerComponent } from './components/notification-scheduler/notification-scheduler.component';

import { IngredientsComponent } from './components/ingredients/ingredients.component';
import { IngredientFormComponent } from './components/ingredients/ingredient-form/ingredient-form.component';
import { IngredientDetailsComponent } from './components/ingredients/ingredient-details/ingredient-details.component';


import { RecipesComponent } from './components/recipes/recipes.component';
import { RecipeFormComponent } from './components/recipes/recipe-form/recipe-form.component';
import { RecipeDetailsComponent } from './components/recipes/recipe-details/recipe-details.component';

import { StepsComponent } from './components/steps/steps.component';
import { StepFormComponent } from './components/steps/step-form/step-form.component';
import { StepDetailsComponent } from './components/steps/step-details/step-details.component';


import { TermsComponent } from './components/terms/terms.component';
import { TermFormComponent } from './components/terms/term-form/term-form.component';
import { TermDetailsComponent } from './components/terms/term-details/term-details.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        // // 
        data: {
          title: 'Dashboard'
        },
      },  
      // {
      //   path: 'notification',
      //   component: NotificationsComponent,
      //   // canActivate: [AuthGuard],
      //   data: {
      //     title: 'notification'
      //   },
      // },
      // {
      //   path: 'notification/details/:id',
      //   component: NotificationDetailsComponent,
      //   // canActivate: [AuthGuard],
      //   data: {
      //     title: 'Notification Details'
      //   },
      // },
      // {
      //   path: 'devices',
      //   component: DevicesComponent,
      //   // canActivate: [AuthGuard],
      //   data: {
      //     title: 'Devices'
      //   },
      // },
      // {
      //   path: 'devices/details/:id',
      //   component: DeviceDetailsComponent,
      //   // canActivate: [AuthGuard],
      //   data: {
      //     title: 'Device Details'
      //   },
      // },
     
      {
        path: 'competition',
        component: competitionsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Competition'
        },
      },
      {
        path: 'activity',
        component: ActivityComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'activity'
        },
      },
      {
        path: 'competition/add',
        component: CompetitionFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New Competition'
        },
      },
      {
        path: 'competition/edit/:id',
        component: CompetitionFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit Competition'
        },
      },
      {
        path: 'competition/details/:id',
        component: CompetitionDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Competition Details'
        },
      },
      {
        path: 'gifts',
        component: GiftsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Gifts'
        },
      },
      {
        path: 'gifts/add',
        component: GiftFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New Gift'
        },
      },
      {
        path: 'gifts/edit/:id',
        component: GiftFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit Gift'
        },
      },
      {
        path: 'gifts/details/:id',
        component: GiftDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Gift Details'
        },
      },
      {
        path: 'members',
        component: MembersComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Members'
        },
      },
      {
        path: 'members/details/:id',
        component: MemberDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Member Details'
        },
      }
      ,
      {
        path: 'articles',
        component: ArticlesComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Articles'
        },
      },
      {
        path: 'articles/add',
        component: ArticleFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New Article'
        },
      },
      {
        path: 'articles/edit/:id',
        component: ArticleFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit Article'
        },
      },
      {
        path: 'articles/details/:id',
        component: ArticleDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Article Details'
        },
      },

      {
        path: 'events',
        component: EventsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Events'
        },
      },
      {
        path: 'events/add',
        component: EventFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New Event'
        },
      },
      {
        path: 'events/edit/:id',
        component: EventFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit Event'
        },
      },
      {
        path: 'events/details/:id',
        component: EventDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Event Details'
        },
      },
      {
        path: 'videos',
        component: VideosComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Videos'
        },
      },
      {
        path: 'videos/add',
        component: VideoFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New Video'
        },
      },
      {
        path: 'videos/edit/:id',
        component: VideoFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit Video'
        },
      },
      {
        path: 'videos/details/:id',
        component: VideoDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Video Details'
        },
      },
      {
        path: 'categories',
        component: CategoriesComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Categories'
        },
      },
      {
        path: 'categories/add',
        component: CategoryFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New Category'
        },
      },
      {
        path: 'categories/edit/:id',
        component: CategoryFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit Category'
        },
      },
      {
        path: 'categories/details/:id',
        component: CategoryDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Category Details'
        },
      },
      {
        path: 'list',
        component: ListComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'List'
        },
      },
      {
        path: 'location',
        component: LocationComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Location'
        },
      },
      {
        path: 'statistics',
        component: StatsComponent,
        data: {
          title: 'Statistics'
        },
      },

      {
        path: 'applications',
        component: ApplicationsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Applications'
        },
      },
      {
        path: 'applications/add',
        component: ApplicationFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New Application'
        },
      },
      {
        path: 'applications/edit/:id',
        component: ApplicationFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit Application'
        },
      },
      {
        path: 'applications/details/:id',
        component: ApplicationDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Application Details'
        },
      },
      {
        path: 'recipes',
        component: RecipesComponent,
        data: {
          title: 'Recipes'
        },
      },
      {
        path: 'recipes/add',
        component: RecipeFormComponent,
        data: {
          title: 'New Recipe'
        },
      },
      {
        path: 'recipes/edit/:id',
        component: RecipeFormComponent,
        data: {
          title: 'Edit Recipe'
        },
      },
      {
        path: 'recipes/details/:id',
        component: RecipeDetailsComponent,
        data: {
          title: 'Recipe Details'
        },
      },
      {
        path: 'steps',
        component: StepsComponent,
        data: {
          title: 'Steps'
        },
      },
      {
        path: 'steps/add',
        component: StepFormComponent,
        data: {
          title: 'New Step'
        },
      },
      {
        path: 'steps/edit/:id',
        component: StepFormComponent,
        data: {
          title: 'Edit Step'
        },
      },
      {
        path: 'steps/details/:id',
        component: StepDetailsComponent,
        data: {
          title: 'Step Details'
        },
      },
      {
        path: 'ingredients',
        component: IngredientsComponent,
        data: {
          title: 'Ingredients'
        },
      },
      {
        path: 'ingredients/add',
        component: IngredientFormComponent,
        data: {
          title: 'New Ingredient'
        },
      },
      {
        path: 'ingredients/edit/:id',
        component: IngredientFormComponent,
        data: {
          title: 'Edit Ingredient'
        },
      },
      {
        path: 'ingredients/details/:id',
        component: IngredientDetailsComponent,
        
        data: {
          title: 'Ingredient Details'
        },
      },

      {
        path: 'cgu',
        component: TermsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'cgu'
        },
      },
      {
        path: 'cgu/add',
        component: TermFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'New cgu'
        },
      },
      {
        path: 'cgu/edit/:id',
        component: TermFormComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Edit CGU'
        },
      },
      {
        path: 'cgu/details/:id',
        component: TermDetailsComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'cgu Details'
        },
      },
      {
        path: 'quizzes',
        component: QuizzesComponent,
        data: {
          title: 'Quizzes'
        },
      },
      {
        path: 'quizzes/add',
        component: QuizFormComponent,
        data: {
          title: 'New Quiz'
        },
      },
      {
        path: 'quizzes/edit/:id',
        component: QuizFormComponent,
        data: {
          title: 'Edit Quiz'
        },
      },
      {
        path: 'quizzes/details/:id',
        component: QuizDetailsComponent,
        data: {
          title: 'Quiz Details'
        },
      },
        {
        path: 'notifications',
        component: NotificationListComponent,
        data: {
          title: 'Notifications'
        },
      },
      {
        path: 'notifications/send',
        component: NotificationSchedulerComponent,
        data: {
          title: 'Notifications'
        },
      },
      

    ]
  },
  { path: '**', component: DefaultLayoutComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class WalkWinRoutingModule { }

